"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Library = exports.withLibraryLoadCheck = exports.ScriptLibraryLoader = void 0;
const core_1 = require("../../core");
var scriptLibraryLoader_1 = require("./loader/scriptLibraryLoader");
Object.defineProperty(exports, "ScriptLibraryLoader", { enumerable: true, get: function () { return scriptLibraryLoader_1.ScriptLibraryLoader; } });
var helper_1 = require("./helper");
Object.defineProperty(exports, "withLibraryLoadCheck", { enumerable: true, get: function () { return helper_1.withLibraryLoadCheck; } });
__exportStar(require("./baseLibrary"), exports);
class Library {
    constructor(name, loader) {
        this.name = name;
        this.loader = loader;
        this.loaded = false;
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const loadInfo = yield this.loader.load();
                this.loaded = true;
                core_1.Log.warn('Library - Library loaded correctly ' + this.name);
                return loadInfo;
            }
            catch (e) {
                const message = 'Library - Error while loading library: ' + this.name;
                core_1.Log.error(message);
                throw Error(message);
            }
        });
    }
    isLoaded() {
        return this.loaded;
    }
}
exports.Library = Library;
//# sourceMappingURL=index.js.map